// Choosing an app "enters" its card: a copy of the card grows into a full-screen window,
// the destination opens underneath it and slowly shows through as the window dissolves.
const GROW_MS = 560;
const REVEAL_MS = 750;

let entering = false;

function canAnimate(event, reduceMotion) {
  if (reduceMotion || event.defaultPrevented || event.button !== 0) return false;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
  if (typeof document.body.animate !== 'function') return false;
  return !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}

const box = (top, left, width, height, borderRadius) => ({
  top: `${top}px`, left: `${left}px`, width: `${width}px`, height: `${height}px`, borderRadius,
});

// Click handler for a chooser card. Without animation support, with reduced motion
// or a modified click the link simply navigates; otherwise `go` runs once the window covers the screen.
export function enterCard(event, reduceMotion, go) {
  if (entering) {
    event.preventDefault();
    return;
  }
  const surface = event.currentTarget.querySelector('.app-chooser__surface');
  if (!surface || !canAnimate(event, reduceMotion)) return;
  event.preventDefault();
  entering = true;

  const from = surface.getBoundingClientRect();
  const frame = document.createElement('div');
  frame.className = `${event.currentTarget.className} app-chooser-entry`;
  frame.setAttribute('aria-hidden', 'true');
  frame.append(surface.cloneNode(true));
  Object.assign(frame.style, box(from.top, from.left, from.width, from.height));
  document.body.append(frame);

  const finish = () => {
    frame.remove();
    entering = false;
  };
  const failsafe = setTimeout(finish, GROW_MS + REVEAL_MS + 4000);

  const radius = getComputedStyle(frame).borderRadius;
  const grow = frame.animate(
    [box(from.top, from.left, from.width, from.height, radius), box(0, 0, window.innerWidth, window.innerHeight, '0px')],
    { duration: GROW_MS, easing: 'cubic-bezier(.2, 0, 0, 1)', fill: 'forwards' },
  );
  // The card's own content fades at once, leaving an empty window.
  [...frame.firstElementChild.children].forEach(child => {
    child.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out', fill: 'forwards' });
  });

  grow.finished.catch(() => {}).then(() => {
    go();
    // Let the destination render for a couple of frames before the window dissolves into it.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const reveal = frame.animate(
        [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(1.04)' }],
        { duration: REVEAL_MS, delay: 80, easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'forwards' },
      );
      reveal.finished.catch(() => {}).then(() => {
        clearTimeout(failsafe);
        finish();
      });
    }));
  });
}
